import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nProvider";
import Home from "@/pages/Home";
import { Toaster } from "@/components/ui/sonner";

const LangRoute = () => (
  <I18nProvider>
    <Home />
  </I18nProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LangRoute />} />
          <Route path="/:lang" element={<LangRoute />} />
          <Route path="/:lang/*" element={<LangRoute />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" />
    </div>
  );
}

export default App;
